export class MyDocFormattingConstants {
    public static readonly MyDocFormatting_TopBarTitle: string = 'My Doc Formattings';
    public static readonly MyDocFormatting_CheckBoxHoverToolTip: string = 'By default only Document Versions in Formatting Phase are displayed. Check this check box to display all the Document Version where you are assigned as Assigned Doc Control, regardless of any other condition.';
    public static readonly MyDocFormatting_ShowAllLabel: string = 'Show All';
    public static readonly MyDocFormatting_ShowInformationIconCheckbox: boolean = true;
    public static readonly MyDocFormatting_IsIncludeAll: boolean = false;
}
